import { useEffect, useState } from 'react';

/**
 * @Description 定位相关事件
 */
const LocationEvent = (
  mapIns,
  locationInfo,
) => {
  const [isPositioning, setIsPositioning] = useState<boolean>(false); // 是否正在定位中--未被其他组件使用

  // 定位完后显示定位marker
  useEffect(() => {
    const { lng, lat } = locationInfo;
    if (!isPositioning && lng && lat) {
      const locationMarker = new window.AMap.Marker({
        position: [lng, lat],
        size: [24, 33],
        anchor: 'center',
        content: '<img src="https://staticres.linhuiba.com/project-custom/locationpc/map_position_marker_red.png" class="locationMarker"/>'
      });
      mapIns.add(locationMarker);
    }
  }, [isPositioning]);

  useEffect(() => { // 避免用户定位失败
    setTimeout(() => {
      setIsPositioning(false);
    }, 5000);
  }, []);

  if (!mapIns) return null;
  return { isPositioning };
};
export default LocationEvent;
